import { type VariantProps, cva } from 'class-variance-authority';
import { HTMLAttributes, forwardRef } from 'react';

import { cn } from '@/lib/utils';

export type PillProps = VariantProps<typeof pillVariants> &
  HTMLAttributes<HTMLDivElement>;

const pillVariants = cva('inline-block rounded-2xl', {
  variants: {
    color: {
      primary: 'border border-primary bg-primary-foreground text-primary',
      tag: 'border border-gray-400 bg-gray-100 text-gray-600',
      success: 'border border-success bg-success-foreground text-success',
      error: 'border border-error bg-error-foreground text-error',
      warning: 'border border-warning bg-warning-foreground text-warning',
      disabled: 'border border-gray-200 bg-gray-50 text-gray-400',
    },
    size: {
      xs: 'px-1 py-0 text-xs',
      sm: 'px-2 py-0 text-sm',
      md: 'px-2 py-1 text-sm',
      lg: 'px-3 py-2 text-base',
    },
  },
  defaultVariants: {
    color: 'primary',
    size: 'md',
  },
});

export type PillColor = PillProps['color'];

export const Pill = forwardRef<HTMLSpanElement, PillProps>(
  ({ color, size, ...props }, ref) => {
    return (
      <span
        {...props}
        ref={ref}
        className={cn(pillVariants({ color, size }), props.className)}
      />
    );
  },
);
